import React from 'react';
import {MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBInput} from 'mdb-react-ui-kit';
import './Login.css'; // import custom CSS file
import {Button} from 'react-bootstrap';

/**
 * La vue du checkin
 * @param {*} props props
 * @return {JSX}
 */
function LoginView(props) {
  return (
    <MDBContainer fluid>
      <MDBRow className="d-flex justify-content-center align-items-center h-100">
        <MDBCol col="12">
          <MDBCard
            className="bg-dark text-white my-5 mx-auto"
            style={{borderRadius: '1rem', maxWidth: '800px'}}>
            <MDBCardBody className="p-5 d-flex flex-column align-items-center justify-content-center mx-auto w-100 text-center">
              <h2 className="fw-bold mb-2 text-uppercase">Connection</h2>
              <p className="text-white-50 mb-5">
                Entrez votre courriel et mot de passe!
              </p>
              {props.errors && props.errors.email && (
                <span className="error">{props.errors.email}</span>
              )}
              <form className="d-flex flex-column align-items-center justify-content-center mx-auto w-100 text-center">
                <MDBInput
                  wrapperClass="mb-4 mx-5 w-100"
                  labelClass="text-white"
                  placeholder="Courriel"
                  type="email"
                  autoComplete="username"
                  required
                  size="lg"
                  value={props.email}
                  onChange={(event) => props.setEmail(event.target.value)} />
                {props.errors && props.errors.password && (
                  <span className="error">{props.errors.password}</span>
                )}
                <MDBInput
                  wrapperClass="mb-4 mx-5 w-100"
                  labelClass="text-white"
                  placeholder="Mot de passe"
                  type="password"
                  autoComplete="current-password"
                  required
                  size="lg"
                  value={props.password}
                  onChange={(event) => props.setPassword(event.target.value)}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                      props.handleSubmit();
                    }
                  }} />
                {props.errors && props.errors.invalid && (
                  <span className="error">{props.errors.invalid}</span>
                )}
              </form>
              <Button
                className="mx-2 px-5"
                color="white"
                size="lg"
                style={{
                  marginTop: '10px',
                  color: 'white',
                  fontSize: 'calc(10px + 2vmin)',
                  backgroundColor: '#363E46',
                  border: 'none',
                  width: '100%',
                }}
                onClick={props.handleSubmit}>
                Se connecter
              </Button>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
}

export default LoginView;
